import React from "react";
import { ScenarioContext } from "scenarios/ScenarioContext";
import { useParams } from "react-router";
import { LoadableFromLoading } from "common/loaders/LoadableFromLoading";
import { scenariosStore } from "scenarios/_stores/scenariosStore";
import { NoSsr } from "@material-ui/core";
import { ScenarioStore } from "scenarios/_stores/ScenarioStore";
import { ScenarioDraftPage } from "scenarios/draft/ScenarioDraftPage";

export function ScenarioDraft() {
    const { scenarioId } = useParams();
    if (!scenarioId) return null;

    return (
        <div>
            <LoadableFromLoading
                loading={scenariosStore.fetchScenario(scenarioId)}
                renderer={(_status, error, scenario) => {
                    if (error || !scenario) return null;
                    return (
                        <NoSsr>
                            <ScenarioContext scenarioStore={new ScenarioStore(scenario)}>
                                <ScenarioDraftPage isEditable={true} />
                            </ScenarioContext>
                        </NoSsr>
                    );
                }}
            />
        </div>
    );
}
